export default {
  title: 'Services',
  sections: {
    offer_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Our Services</div>Become a partner company and co-entrepreneur',
            text2: 'Our solutions for Swiss<br> engineering companies',
            image: '/seu/latest-assets/seu_37.jpg'
          }
        },
      }
    },
    offer_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Services'
          }
        }
      }
    },
    offer_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_34.jpg'
          }
        }
      }
    },
    offer_text_section: {
      fields: {
        field_one: {
          value: {
            text: 'BUILD A NEW FUTURE <div class="text-highlight">with SEU</div>'
          }
        },
        field_two: {
          value: {
            text: 'Being part of SEU means building on success and growth. But it also means preserving the spirit of your company.'
          }
        },
        field_three: {
          value: {
            text: 'You lead an established engineering firm and are looking for solutions to the challenges of the market – lack of qualified personnel, cost pressure, digitalization. You care deeply about the future of your SME and you’re looking for leaders to help you push forward. As an entrepreneur, you wonder how your SME can implement innovation in its operations so that it can stay competitive in the future. Your management team members are outstanding experts in their fields rather than entrepreneurs, or they don’t have the financial resources to take over your company.'
          }
        },
      }
    },
    offer_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Services'
          }
        }
      }
    },
    offer_text_2_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Industry-specific solutions<br> By engineers, for engineers</div>'
          }
        },
        // field_two: {
        //   value: {
        //     text: 'Through centralization at Group level, the SEU enables sustainable solutions, efficient processes, significant cost savings, and optimized capacity utilization. In addition, it specifically promotes junior staff and has a positive magnetic effect on skilled workers.'
        //   }
        // },
        field_three: {
          value: {
            text: 'As a SEU partner company, you’ll benefit in many areas, including cross-selling opportunities and expansion of your range of services, professional personnel recruiting and development, management support in administration and IT, targeted marketing and sales for acquiring new clients as well as use of established offshore production facilities. ',
            text2: 'In sum: Your engineering company will benefit from palpable synergy effects.',
          }
        },
      }
    },
    offer_features_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                name: 'Personnel Development',
                image: '/seu/latest-assets/seu_08.jpg',
                title: 'Empowering employees and promoting career development',
                subTitle: `As a partner company, we’ll support you in recruiting, retaining and continuing the training of your skilled professionals and managers through the SEU Academy and the SEU employee participation program.
<p>A process with a magnetic effect: Through the targeted promotion of qualified employees, we not only help your company stay competitive, but also make it an attractive option for skilled professionals.</p>
<p>Employees should be able to develop their full potential. If desired, you can participate in the SEU Group’s success as a <a class="text-highlight" href="/en/strategy#entrepreneur">co-entrepreneur</a>.  </p>
`,
                buttonLabel: 'More',
                buttonLabelLess: 'Less',
                id: 'personnel_development'
              },
              {
                name: 'Managementsupport',
                image: '/seu/latest-assets/seu_09.jpg',
                title: 'Consultation and guidance',
                subTitle: `As a group, we take joint responsibility for the growth of each individual partner company and personally support their management teams in the process. In daily business, we’ll help you establish efficient structures and processes for management and administration.
<p>From the start, we’ll assist with smooth integration into the SEU Group. We’ll keep an eye on industry developments nationally and internationally to optimally promote, network and continue developing your potential and resources. </p>`,
                buttonLabel: 'More',
                buttonLabelLess: 'Less',
                id: 'management_support'
              },
              {
                name: 'Growth',
                image: '/seu/latest-assets/seu_14.jpg',
                title: 'Take advantage of synergies and combine resources\n',
                subTitle: `The size of the SEU Group lets you increase the utilization of your production facilities and offers a reliable solution to bottlenecks.<p>With each integration of a partner company, we continue to expand our knowledge. We’ll support you in continuously optimizing products, services and business processes to enable continued growth. We also ensure that digital tools are used and developed jointly.</p>                         `,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },
              {
                name: 'Digitalization',
                image: '/seu/latest-assets/seu_10.jpg',
                title: 'Lean and efficient processes ',
                subTitle: `Wherever your company is right now, we’re sparring partners for all questions related to digital transformation.
<p> Through the use of digital services and technologies, we jointly optimize the competitiveness of each individual partner company. We make business processes leaner, more efficient and even more ready for the future by utilizing the latest developments in the area of AI and machine learning.</p>`,
                buttonLabel: 'More',
                buttonLabelLess: 'Less',
                id: 'digitalization'
              },
              {
                name: 'Acquiring New Clients',
                image: '/seu/latest-assets/seu_11.jpg',
                title: 'Cross-selling and new markets',
                subTitle: ` We’ll help you expand your client portfolio and develop new target groups, sales areas and customer segments.
                          <p>Expand your company’s range of services by submitting combined tenders for larger projects. It will help you remain competitive, agile and flexible. In addition, the SEU Group creates opportunities for profitable cross-selling and the targeted development of cross-selling strategies.
</p>
                          `,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },
              {
                name: 'Marketing and Sales',
                image: '/seu/latest-assets/seu_12.jpg',
                title: 'Internal and external strategies',
                subTitle: `
                 Our expertise in marketing, communication, sales and employer branding will be at your unlimited disposal.
                 <p>We’ll analyze potential synergies to achieve a powerful presence in digital channels and support your social media strategy development.
</p>
         `,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },
              {
                name: 'Offshore Production',
                image: '/seu/latest-assets/seu_13.jpg',
                title: 'Efficiency and impact',
                subTitle: `
               Shared use of existing and established offshore production facilities is an asset to any project and represents added value in the long run.
            <p>It noticeably and reliably reduces production costs. At the same time, it makes it easier to manage the shortage of skilled workers – a major contribution to your competitiveness.
</p>
                `,
                buttonLabel: 'More',
                buttonLabelLess: 'Less'
              },

              {
                name: 'Economic Security',
                image: '/seu/latest-assets/seu_15.jpg',
                title: 'Financing, cost reduction and growth',
                subTitle: `
                  Through consistent cost reduction, we ensure an improved EBITDA. We achieve that though economies of scale, optimized purchasing conditions and out-tasking abroad, among other things. The numerous synergy effects within the SEU Group will help you meet your key performance indicators.

             `,
                buttonLabel: 'More',
                buttonLabelLess: 'Less',
                id: 'economic_security'
              },
              {
                name: 'Succession Solutions',
                image: '/seu/latest-assets/seu_07.jpg',
                title: 'Individual and forward-looking',
                subTitle: `We’ll support you as a partner company in identifying, selecting and developing suitable successors. Do you already have a desired candidate – but the necessary financial resources for an acquisition are lacking? By integrating into the group, we’re creating flexibility for personnel decisions affecting future management.
<p> Together we’ll work to establish owner-independent management and to define and implement a robust, long-term business strategy </p>`,
                buttonLabel: 'More',
                buttonLabelLess: 'Less',
                id: 'succession'
              },
            ]
          }
        }
      }
    },
    offer_divider3_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Services'
          }
        }
      }
    },
    offer_text_3_section: {
      fields: {
        field_one: {
          value: {
            text: 'From owner to business<br> partner, from founder<br> to co-entrepreneur <div class="text-highlight"><br/>You’ve earned it</div>'
          }
        },
        field_two: {
          value: {
            text: 'You can breathe easy. Your efforts have paid off. What you’ve achieved will endure. Your company will continue to operate independently and under the same name. It’s what you deserve.',
          }
        },
        field_three: {
          value: {
            text: 'Above all, it’s great to keep you on board. Because you know your company best. You represent consistency and values and build trust.',
            text2: 'As a partner of SEU, you’ll benefit from our size, professionalism and capacity for innovation without sacrificing your entrepreneurial independence. Your clients and employees will enjoy continuity, while as a co-entrepreneur, you’ll invest in SEU and participate in our shared success.',
            text3: 'Our broad portfolio of products and services will support you and create cross-selling opportunities. You can look forward to individualized development prospects for your employees and the chance to actively shape the future of the SEU Group.'
          }
        },
      }
    },
    offer_call_to_action_section: {
      fields: {
        field_one: {
          value: {
            text: 'Do you have questions about the individual steps of the transition?',
            text2: 'We’re happy to answer your questions in personal conversation.',
            buttonLabel: 'Contact us',
            buttonLink: '/en/contact'
          }
        },
      }
    },
    offer_divider4_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Services'
          }
        }
      }
    },
    offer_text_4_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Be a partner<br> company<br></div> on an equal<br> footing'
          }
        },
        field_two: {
          value: {
            text: 'As exceptional as your company: strategic and operational synergy effects'
          }
        },
        field_three: {
          value: {
            text: 'As our partner company, you’ll benefit from the size, professionalism, innovative spirit and impact of SEU – with almost unlimited entrepreneurial independence. The group will support you with a broad and well-diversified portfolio of products and services and create opportunities for cross-selling.'
          }
        },
        field_four: {
          value: {
            text: 'For your clients, nothing will change. Your brand, contact partners and management of the individual partner companies will remain the same. SEU offers employees individual perspectives for professional development.'
          }
        },
      }
    },
    offer_call_to_action_2_section: {
      fields: {
        field_one: {
          value: {
            text: 'Ready?',
            text2: 'Become part of Swiss Engineers United.',
            buttonLabel: 'About us',
            buttonLink: '/en/about',
            image: '/seu/latest-assets/seu_20.jpg',
          }
        },
      }
    },
  }
}
